<template>
  <div v-if="visible" class="modal-backdrop-wrapper">
    
    <div class="modal d-block" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content border border-primary">
          <div class="modal-header border border-primary">
            <h5 class="modal-title">
              <i v-if="icon"
                  :class="['fas', iconClass,'mr-3']"
                  :style="{ fontSize: '20px', color: iconColor }">
              </i>
              
              {{ title }}</h5>
          </div>
          <div class="modal-body">
           <div class="progress-bar progress-bar-striped" role="progressbar"  :style="{'width':getProgress}">
                {{ progress }}%
          </div>  
          </div>
          

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
 props:['progress'],
  data() {
    return {
      visible    : false,
      message    : '',
      title      : 'ATTENZIONE',
      spinner    : false,
      icon       : ''
      

    }
  },

computed: {
  
    getProgress()
    {
      let p = this.progress
      return p + "%";
    },


  iconClass() {
    const map = {
      1: 'fa-bell',
      2: 'fa-exclamation',
      3: 'fa-exclamation-triangle',
      4: 'fas fa-check-double',
      5: 'fas fa-bullhorn',
      6: 'far fa-hourglass'
    }

    return map[this.icon] || ''
  },

  iconColor() {
    const colors = {
      1: 'blue',
      2: 'blue',
      3: 'red',
      4: 'green',
      5: 'blue',
      6: 'blue'
    }

    return colors[this.icon] || 'blue'
  }
  },

  methods: {

    show(msg = '', options = {},icon='') {
      this.message = msg
      this.title   = options.title || 'ATTENZIONE'
      this.spinner = options.spinner || false
      this.icon    = icon
      this.visible = true

      return new Promise(resolve => {
        const unwatch = this.$watch('visible', val => {
          if (!val) {
            unwatch()
            resolve()
          }
        })
      })
    },
    close() {
      
      this.visible = false
      this.message = ''
      
    },
   
  }
}
</script>

<style scoped>
.modal-backdrop-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1050; /* sopra tutto */
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.5); /* backdrop semi-trasparente */
}

.modal.d-block {
  display: block;
  z-index: 1060; /* sopra il backdrop */
}

@keyframes blinkBorder {
  0%   { box-shadow: 0 0 5px rgba(0,123,255,0.4); }
  50%  { box-shadow: 0 0 20px rgba(0,123,255,1); }
  100% { box-shadow: 0 0 5px rgba(0,123,255,0.4); }
}

.blink-border {
  animation: blinkBorder 1s infinite;
}
.modal-message {
  white-space: pre-line;
}
</style>